export default __webpack_public_path__ + "static/tyquan ward-2ffa792c0af40eaa4d44b784efb0e27a.png";